var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 52,
    viewBox: "0 0 153 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8451,
    cy: 32.6888,
    r: 32.6888,
    fill: "#FFB923"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9133 39.3769H16.9728L15.3793 44.0815H8.58789L18.2249 17.4471H25.7371L35.3741 44.0815H28.5068L26.9133 39.3769ZM25.2439 34.3687L21.9431 24.6179L18.6802 34.3687H25.2439Z",
    fill: "#1B69B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2098 22.9105L48.9305 54.1358H41.9494L46.8059 43.3607L38.1933 22.9105H45.44L50.3344 36.1519L55.1908 22.9105H62.2098Z",
    fill: "#1B69B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7003 44.3851C76.8538 44.3851 75.2097 44.0689 73.768 43.4365C72.3262 42.8042 71.188 41.9442 70.3533 40.8566C69.5186 39.7436 69.0507 38.5042 68.9495 37.1384H75.3615C75.4374 37.8719 75.7788 38.4663 76.3859 38.9216C76.9929 39.3769 77.7391 39.6045 78.6244 39.6045C79.4338 39.6045 80.0535 39.4527 80.4835 39.1492C80.9388 38.8204 81.1664 38.403 81.1664 37.8972C81.1664 37.2901 80.8503 36.8475 80.2179 36.5692C79.5856 36.2657 78.5612 35.9369 77.1447 35.5828C75.6271 35.2287 74.3624 34.8619 73.3506 34.4825C72.3389 34.0778 71.4662 33.4581 70.7327 32.6234C69.9992 31.7634 69.6324 30.6125 69.6324 29.1708C69.6324 27.9567 69.9612 26.8564 70.6189 25.8699C71.3018 24.8582 72.2883 24.0614 73.5783 23.4797C74.8935 22.8979 76.4491 22.607 78.245 22.607C80.9008 22.607 82.9876 23.2647 84.5052 24.5799C86.0481 25.8952 86.9334 27.6405 87.1611 29.8158H81.1664C81.0653 29.0823 80.7364 28.5005 80.18 28.0705C79.6488 27.6405 78.9406 27.4255 78.0553 27.4255C77.2965 27.4255 76.7147 27.5773 76.31 27.8808C75.9053 28.159 75.703 28.5511 75.703 29.057C75.703 29.664 76.0191 30.1193 76.6515 30.4228C77.3091 30.7264 78.3209 31.0299 79.6867 31.3334C81.255 31.7381 82.5323 32.1428 83.5188 32.5475C84.5052 32.9269 85.3652 33.5593 86.0987 34.4446C86.8576 35.3045 87.2496 36.4681 87.2749 37.9351C87.2749 39.1745 86.9208 40.2874 86.2126 41.2739C85.5296 42.2351 84.5305 42.9939 83.2152 43.5504C81.9252 44.1068 80.4203 44.3851 78.7003 44.3851Z",
    fill: "#1B69B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.458 44.0815L100.008 35.2034V44.0815H93.5206V16.0053H100.008V31.5231L106.42 22.9105H114.426L105.624 33.534L114.502 44.0815H106.458Z",
    fill: "#1B69B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.028 30.1117V43.9468H119.518V30.1117H126.028Z",
    fill: "#1B69B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.028 27.1277V22.7872H119.518V27.1277H126.028Z",
    fill: "#1B69B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.321 16.2766V43.9468H132.811V16.2766H139.321Z",
    fill: "#1B69B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.884 7.86702V43.9468H146.373V7.86702H152.884Z",
    fill: "#1B69B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.43536983.svg";
export { ForwardRef as ReactComponent };